import PropTypes from 'prop-types'
import { memo } from 'react'
import { useIntl } from 'react-intl'
import { usersAPI } from '../../../../../proxyConfig/apiUrls'
import { useAccessSearchParam } from '../../../../zustand/authentication/use-auth-store'
import ListItemComponent from '../../../stories/molecules/list-items'
import { useGetAvatarQuery } from '../../../../react-query/avatar/query/use-get-avatar-query'
import { iconSizeOptions } from '../../../stories/atoms/icons/icons-sizes'
import StatusIndicationComponent from '../../../stories/atoms/status-indication'
import { statusIndicationMemberVariantOptions } from '../../../stories/atoms/status-indication/constants'
import { handleRoleColor } from '../../constants'
import { isEmpty } from 'lodash'

const MemberItem = ({
  item,
  isSelected = false,
  onToggleSelect = () => {}
}) => {
  const { formatMessage } = useIntl()
  const accessSearchParam = useAccessSearchParam()
  const profilePicture = item
    ? `${usersAPI}/${item?.userId}/avatar${accessSearchParam()}`
    : null
  const { data: cachedAvatarImage } = useGetAvatarQuery(profilePicture)

  if (isEmpty(item)) return null

  return (
    <ListItemComponent.Item
      itemKey={item.userId}
      isCheck={isSelected}
      leadingIcon={
        <StatusIndicationComponent
          image={cachedAvatarImage}
          size={iconSizeOptions['ICON-L']}
          variant={statusIndicationMemberVariantOptions.MEMBER}
        />
      }
      title={`${item.firstName} ${item.lastName}`}
      secondaryText={item.email}
      badge={{
        label:
          formatMessage({ id: `personas_roleLabel${item.role}` }) || item.role,
        color: handleRoleColor(item.role)
      }}
      style={{ borderRadius: 0, border: 0 }}
      onCheck={() => onToggleSelect(item.userId)}
      noPadding
    />
  )
}

MemberItem.propTypes = {
  item: PropTypes.object,
  isSelected: PropTypes.bool,
  onToggleSelect: PropTypes.func
}

const MemoizedMemberItem = memo(MemberItem)
MemoizedMemberItem.displayName = 'MemberItem'

export default MemoizedMemberItem
